import React from 'react';
import ReactOnRails from 'react-on-rails';
import {showMoney} from './lib/money';
import MoneyDisplay from './money-display';
import Stats from '../shared_components/stats.js';
import Question from './question';
import AnswerEntry from './answer-entry';
import AnswerFeedback from './answer-feedback';

export default class Money extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      totalAttempted: 0,
      totalCorrect: 0,
      currentProblem: showMoney(),
      currentProblemAttempted : false,
      currentAttemptCorrect : false
    };

    this.updateStats = this.updateStats.bind(this);
    this.createNewProblem = this.createNewProblem.bind(this);
  }

  // changes answer feedback component, keeps track of total and correct attempts
  // called by AnswerEntry when enter is pressed on input
  // answerCorrect : true or false depending on whether user submitted correct answer 
	updateStats(answerCorrect) {
		this.setState({
			totalAttempted: this.state.totalAttempted + 1,
			totalCorrect: answerCorrect ? this.state.totalCorrect + 1 : this.state.totalCorrect,
			currentProblemAttempted : true, 
      currentAttemptCorrect : answerCorrect
		});
	}

	createNewProblem(){
		this.setState({
			currentProblem: showMoney(),
			currentProblemAttempted : false,
      currentAttemptCorrect : false
		});
	}

  render(){
    return (
      <div>
        <Stats 
          totalAttempted={this.state.totalAttempted} 
          totalCorrect={this.state.totalCorrect}
          totalAttemptedClass= "money-stats__attempted"
          totalCorrectClass= "money-stats__correct" />
        <MoneyDisplay gameState={this.state.currentProblem} />
        <Question />
        <AnswerFeedback 
          gameState={this.state.currentProblem} 
          visible={this.state.currentProblemAttempted} 
          currentAttemptCorrect={this.state.currentAttemptCorrect}
        />
        <AnswerEntry 
          gameState={this.state.currentProblem} 
          updateStats={this.updateStats} 
          createNewProblem={this.createNewProblem} />
        </div>
    );
  }
}

ReactOnRails.register({ Money });



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/money/component.js
 **/